import { render, staticRenderFns } from "./dispatch.vue?vue&type=template&id=49342d94&scoped=true"
import script from "./dispatch.vue?vue&type=script&lang=ts"
export * from "./dispatch.vue?vue&type=script&lang=ts"
import style0 from "./dispatch.vue?vue&type=style&index=0&id=49342d94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49342d94",
  null
  
)

export default component.exports